/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define(["backbone", "service/channel", "jquery", "underscore"], function(Backbone, Channel, $, _) {

  /**
   *
   * OpenSearchChannel wraps another channel and adapts request and responses.
   * 
   * Attributes:
   *
   * * parentChannel: the channel used for communicating
   *
   * Options:
   *
   * * urlTemplate: the OpenSearch url template (http://www.opensearch.org/Specifications/OpenSearch/1.1#OpenSearch_URL_template_syntax)
   *   (currently only searchTerm and count are usable)
   *
   * Mode of operation
   * -----------------
   *
   * Overwrites the **call**-function of Channel to adapt the request.
   * Overwrites the **success**-function of the wrapped channel to parse the response.
   *
   */
  var OpenSearchChannel = Channel.extend({

    initialize: function (attributes, options) {
      options = options || {};
      this.urlTemplate = options.urlTemplate;

      Channel.prototype.initialize.apply(this, arguments);

      var that = this,
          parentChannel = this.get("parentChannel"),
          originalSuccess = parentChannel.success || parentChannel.prototype.success;

      parentChannel.success = function (data) {
        return originalSuccess.apply(parentChannel, [that.adaptResponse(data)].concat(Array.prototype.slice.apply(arguments, [1])));
      }
    },

    call: function(path, request, responseObserver) {
      if (this.isSearch(path)) {
        return this.get("parentChannel").call(this.getUrl(request), null, responseObserver, "text");
      }

      var that = this,
          promise = new Channel.DeferredCallFinished(this);

      // return empty result for all other services
      _.defer(function () {
          that.success(
            {},
            promise,
            responseObserver
          );
      });

      return promise;
    },

    getUrl: function (request) {
      var query = request && request.user && request.user.query && request.user.query.unparsed,
          count = request && request.count;

      return this.urlTemplate.replace(/\{searchTerms\}/g, query).replace(/\{count\??\}/g, count);
    },

    isSearch: function (path) {
      return path === "search";
    },

    adaptResponse: function (data) {
      return {
        resultset: {
          results: $(data).find("entry").map(function (value, index) {
              return {
                id: $(this).find("id").text(),
                rank_score: 99,
                properties: [{
                    id: "title",
                    data: [{html: $(this).find("title").text() }]
                  },{
                    id: "content",
                    data: [{html: $(this).find("content").text() }]
                  },{
                    id: "actions",
                    properties: $(this).find("link").map(function () {
                        var $this = $(this),
                            name = $this.attr("title"),
                            href = $this.attr("href");

                        return {
                          id: name,
                          name: name,
                          href: href,
                          data: [{html: '<a href="' + href + '">' + name + '</a>', value : {
                                href: href,
                                rel: "action"
                          }}],
                        }
                    })
                }]
              }
          })
        }
      };
    }
  });
  
  return OpenSearchChannel;
});

